import withFeatureBranch from '@wix/da-react-context/pkg/flags/withFeatureBranch';
import SiteHeaderMobileV2 from '../SiteHeaderMobile.top_nav_tweaks';
import SiteHeaderMobile from './SiteHeaderMobile';
import SiteHeaderMobileContainer from './SiteHeaderMobile.container';

export default withFeatureBranch({ top_nav_tweaks: SiteHeaderMobileV2 })(
  SiteHeaderMobileContainer(SiteHeaderMobile)
);
